import { render, staticRenderFns } from "./RidesPerStatus.vue?vue&type=template&id=218eaa1b&scoped=true&"
import script from "./RidesPerStatus.vue?vue&type=script&lang=js&"
export * from "./RidesPerStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218eaa1b",
  null
  
)

export default component.exports